import { render, staticRenderFns } from "./TableRules.vue?vue&type=template&id=62b4e0a9&scoped=true&"
import script from "./TableRules.vue?vue&type=script&lang=js&"
export * from "./TableRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b4e0a9",
  null
  
)

export default component.exports